namespace GeniuzPOS.Inventory {
    export interface IcStockCountTranForm {
        Id: Serenity.IntegerEditor;
        LineItemNo: Serenity.IntegerEditor;
        PluCode: Serenity.LookupEditor;
        ItemRemark: Serenity.StringEditor;
        QtyCount: Serenity.DecimalEditor;
        SellUnit: Serenity.StringEditor;
        SellUnitRatio: Serenity.DecimalEditor;
        SkuCode: Serenity.LookupEditor;
        StkQtyCount: Serenity.DecimalEditor;
        PurUnitRatio: Serenity.DecimalEditor;
        PurUnitPrice: Serenity.DecimalEditor;
    }

    export class IcStockCountTranForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockCountTran';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockCountTranForm.init)  {
                IcStockCountTranForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(IcStockCountTranForm, [
                    'Id', w0,
                    'LineItemNo', w0,
                    'PluCode', w1,
                    'ItemRemark', w2,
                    'QtyCount', w3,
                    'SellUnit', w2,
                    'SellUnitRatio', w3,
                    'SkuCode', w1,
                    'StkQtyCount', w3,
                    'PurUnitRatio', w3,
                    'PurUnitPrice', w3
                ]);
            }
        }
    }
}
